import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { MapPin, Radio } from "lucide-react";
import { api } from "@/lib/api";
import { MatchCard } from "@/components/MatchCard";
import { SkeletonCard, Empty } from "@/components/States";

export default function Discovery() {
  const { mode } = useParams();
  const nav = useNavigate();
  const active = mode === "online" ? "online" : "near-me";
  const [state, setState] = useState({ loading: true, results: [], meta: {} });

  useEffect(() => {
    setState((s) => ({ ...s, loading: true }));
    api.get(`/discovery/${active}`).then(({ data }) => setState({ loading: false, results: data.results, meta: data }))
      .catch(() => setState({ loading: false, results: [], meta: {} }));
  }, [active]);

  return (
    <div className="space-y-5" data-testid="discovery-page">
      <h1 className="font-serif text-3xl font-bold text-[#58111A]">Discover</h1>
      <div className="flex gap-2">
        <button onClick={() => nav("/app/discover/near-me")} data-testid="tab-near-me" className={`text-sm font-medium px-4 py-2 rounded-full border flex items-center gap-1.5 ${active === "near-me" ? "bg-[#781826] text-white border-[#781826]" : "bg-white border-[#E8DFD1] text-[#605255]"}`}><MapPin className="w-4 h-4" /> Near Me</button>
        <button onClick={() => nav("/app/discover/online")} data-testid="tab-online" className={`text-sm font-medium px-4 py-2 rounded-full border flex items-center gap-1.5 ${active === "online" ? "bg-[#781826] text-white border-[#781826]" : "bg-white border-[#E8DFD1] text-[#605255]"}`}><Radio className="w-4 h-4" /> Online Now</button>
      </div>
      {active === "near-me" && state.meta.city && <p className="text-sm text-[#605255]">Members in and around <span className="font-semibold text-[#781826]">{state.meta.city}</span>.</p>}
      {state.loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">{[...Array(6)].map((_, i) => <SkeletonCard key={i} />)}</div>
      ) : state.results.length === 0 ? (
        <Empty icon={active === "online" ? Radio : MapPin} title={active === "online" ? "No one online right now" : "No nearby members yet"} message={active === "online" ? "Check back soon — members appear here when they're active." : "Add your city in your profile to discover members near you."} action={<a href="/app/profile/edit" className="btn-primary">Update Location</a>} />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">{state.results.map((p) => <MatchCard key={p.user_id} p={p} />)}</div>
      )}
    </div>
  );
}
